/*
 * Copyright 2025 The Kubeflow Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Internal artifact custom-property keys that should not be rendered as user content. */
export const RESERVED_ARTIFACT_CUSTOM_PROPERTIES: ReadonlySet<string> = new Set([
  'store_session_info',
]);

/** Returns true if the key is an internal/reserved artifact custom property. */
export function isReservedArtifactProperty(key?: string): boolean {
  return !!key && RESERVED_ARTIFACT_CUSTOM_PROPERTIES.has(key);
}
